// function that removes whitespaces and special characters from a string
export const removeSpecialCharacters = (str: string) => {
  return str ? str.replace(/[^a-zA-Z0-9]/g, '') : str
}

const domainWithoutWWWRegex = /http(s)?(:)?(\/\/)?|(\/\/)?(www\.)?/g

// function that converts a string to lowercase and returns proper lowercased type if it exists
type LowerCase<T extends string> = Lowercase<T>
export const lowerCase = <T extends string>(str: T) =>
  str ? str.toLowerCase() : (str as LowerCase<T>)

export const htmlDecode = (str: string) => {
  return str ? decodeURIComponent(str)?.replaceAll('+', ' ') : str
}

export const decodeUri = (str: string) => {
  return str ? decodeURIComponent(str) : str
}

export const encodeUri = (str: string) => {
  return str ? encodeURIComponent(str) : str
}

export const replaceWWW = (domain: string): string => domain.replace(domainWithoutWWWRegex, '')
